import cn from 'classnames'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

const ToggleSwitch = ({ toggled, onToggleOn, onToggleOff, className = '' }) => {
  const { t } = useTranslation()
  
  const handleToggle = () => {
    toggled ? onToggleOff() : onToggleOn()
  }

  return (
    <div className={cn(styles.toggleContainer, className)} onClick={handleToggle}>
      <div className={`${styles.background} ${toggled ? styles.toggled : ''}`}></div>
      <div className={`${styles.label} ${toggled ? styles.inactiveText : styles.activeText}`}>{t('toggle_off')}</div>
      <div className={`${styles.label} ${toggled ? styles.activeText : styles.inactiveText}`}>{t('toggle_on')}</div>
    </div>
  )
}

export default ToggleSwitch
